import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ProductCardNew } from '../../ProductCardNew/rn';
import { ProductCard } from '../../ProductCard/rn';
import React, { useState, useRef, useLayoutEffect } from 'react';
import { Image, Text, View } from 'react-native';
import ImgWrong from '../../../assets/images/something_wrong.png';
import ImgNone from '../../../assets/images/order_none.png';
import EmptySelect from '../../../assets/images/rn/EmptySelect';
import { ListLoader } from '../../Loader/rn';
import { InfiniteScroll } from '../../InfiniteScroll/rn';
import { useLocale } from '../../LocaleProvider/rn';
import { ORDER_STH_WENT_WRONG_TEXT, NO_ORDERS_YET_TEXT } from '../../../utils/constants';
import styles from './styles';
export var ProductList = function ProductList(props) {
  var _props$active = props.active,
    active = _props$active === void 0 ? true : _props$active,
    onLoadMore = props.onLoadMore,
    type = props.type,
    selectOrderText = props.selectOrderText,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 5 : _props$limit,
    itemText = props.itemText,
    itemsText = props.itemsText,
    userType = props.userType,
    showOrderId = props.showOrderId,
    onButtonClick = props.onButtonClick,
    showLoading = props.showLoading,
    isProductCardNew = props.isProductCardNew,
    watchFn = props.watchFn,
    _props$searchContent = props.searchContent,
    searchContent = _props$searchContent === void 0 ? '' : _props$searchContent,
    _props$isInSearch = props.isInSearch,
    isInSearch = _props$isInSearch === void 0 ? false : _props$isInSearch,
    _props$isUIOptimisati = props.isUIOptimisation,
    isUIOptimisation = _props$isUIOptimisati === void 0 ? false : _props$isUIOptimisati,
    _props$productOrOrder = props.productOrOrderEmptyText,
    productOrOrderEmptyText = _props$productOrOrder === void 0 ? '' : _props$productOrOrder,
    _props$defaultPageNum = props.defaultPageNumStartIndex,
    defaultPageNumStartIndex = _props$defaultPageNum === void 0 ? 0 : _props$defaultPageNum,
    _props$noMoreText = props.noMoreText,
    noMoreText = _props$noMoreText === void 0 ? '' : _props$noMoreText,
    onTouchEnd = props.onTouchEnd;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    listData = _useState2[0],
    setListData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isError = _useState6[0],
    setIsError = _useState6[1];
  var _useState7 = useState(defaultPageNumStartIndex),
    _useState8 = _slicedToArray(_useState7, 2),
    startIndex = _useState8[0],
    setStartIndex = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    hasMore = _useState10[0],
    setHasMore = _useState10[1];
  var containerRef = useRef(null);
  var scrollViewScrollTop = useRef(0); // const { tracker, result } = useComponentTracking({
  //   componentTrackingData: componentTrackingData,
  //   componentData: { ...props },
  // });
  // const elementScrollTrack = new ElementScrollTrackManage();
  // const { panelOrderScroll: panelOrderScrollTracking } = result;

  var _useLocale = useLocale(),
    trans = _useLocale.trans; // const orderScrollTrackHandler = () => {
  //   console.log('触发滚动上报', panelOrderScrollTracking?.trackingScroll, panelOrderScrollTracking);
  //   if (panelOrderScrollTracking?.trackingScroll) {
  //     tracker.scroll(panelOrderScrollTracking.trackingScroll);
  //   }
  // };
  // const addScrollTrackEvent = () => {
  //   if (containerRef.current) {
  //     elementScrollTrack.addTrack(containerRef.current, ScrollType.Vertical, {
  //       scrollCallback: orderScrollTrackHandler,
  //       containerElement: containerRef.current,
  //     });
  //   }
  // };
  // useEffect(() => {
  //   addScrollTrackEvent();
  //   return elementScrollTrack.removeAllTrack;
  // }, [panelOrderScrollTracking, containerRef.current]);

  var loadMoreCb = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var res, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(disabled || !hasMore || loading)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return onLoadMore({
                page_num: startIndex,
                page_size: limit,
                status: type,
                user_type: userType,
                is_in_search: isInSearch,
                search_content: isInSearch ? searchContent : undefined
              });
            case 6:
              res = _context.sent;
              data = res.data;
              if (data) {
                if (data.length === 0) {
                  setHasMore(false);
                  setLoading(false);
                } else {
                  setStartIndex(startIndex + 1);
                  setListData([].concat(_toConsumableArray(listData), _toConsumableArray(data)));
                  setLoading(false);
                  setHasMore(data.length >= limit);
                }
              } else {
                setLoading(false);
                setIsError(true); // setHasMore(false); // https://jira.shopee.io/browse/SPCB-29697
              }

              _context.next = 16;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              setLoading(false);
              setIsError(true);
              console.error(_context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function loadMoreCb() {
      return _ref.apply(this, arguments);
    };
  }();
  var orderWrong = /*#__PURE__*/React.createElement(View, {
    style: styles.tipContainer
  }, /*#__PURE__*/React.createElement(Image, {
    source: ImgWrong,
    alt: "wrong",
    style: styles.tipImage
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles.tipText
  }, trans(ORDER_STH_WENT_WRONG_TEXT)));
  var orderEmpty = /*#__PURE__*/React.createElement(View, {
    style: styles.tipContainer
  }, /*#__PURE__*/React.createElement(Image, {
    source: ImgNone,
    alt: "empty",
    style: styles.tipImage
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles.tipText
  }, trans(NO_ORDERS_YET_TEXT)));
  var productOrOrderEmpty = /*#__PURE__*/React.createElement(View, {
    style: styles.tipSelectContainer
  }, /*#__PURE__*/React.createElement(EmptySelect, null), /*#__PURE__*/React.createElement(Text, {
    style: styles.tipSelectText
  }, productOrOrderEmptyText));
  var orderLoading = /*#__PURE__*/React.createElement(View, {
    style: styles.loadingContainer
  }, /*#__PURE__*/React.createElement(ListLoader, null));
  var noMoreTextContainer = /*#__PURE__*/React.createElement(View, {
    style: styles.noMoreContainer
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.noMoreText
  }, noMoreText));
  useLayoutEffect(function () {
    if (active) {
      if (!listData.length) {
        loadMoreCb();
      }
      setTimeout(function () {
        var _containerRef$current, _containerRef$current2;
        (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.scrollTo) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.call(_containerRef$current, scrollViewScrollTop.current);
      });
    }
  }, [active]);
  if (!active) {
    return null;
  }
  return listData.length > 0 ? /*#__PURE__*/React.createElement(InfiniteScroll, {
    ref: containerRef,
    showLoading: showLoading,
    onLoadMore: loadMoreCb,
    onScrollTopChange: function onScrollTopChange(scrollTop) {
      scrollViewScrollTop.current = scrollTop;
    },
    onTouchEnd: onTouchEnd
  }, listData.map(function (item, index) {
    return isProductCardNew ? /*#__PURE__*/React.createElement(ProductCardNew, _extends({}, item, {
      key: item.orderId,
      selectOrderText: selectOrderText,
      itemText: itemText,
      itemsText: itemsText,
      showOrderId: showOrderId,
      onButtonClick: onButtonClick,
      userType: userType,
      index: index,
      watchFn: watchFn // componentTrackingData={componentTrackingData}
    })) : /*#__PURE__*/React.createElement(ProductCard, _extends({}, item, {
      key: item.orderId,
      selectOrderText: selectOrderText,
      itemText: itemText,
      itemsText: itemsText,
      showOrderId: showOrderId,
      onButtonClick: onButtonClick,
      userType: userType,
      watchFn: watchFn // componentTrackingData={componentTrackingData}
    }));
  }), !hasMore && noMoreTextContainer) : loading ? orderLoading : isError ? orderWrong : isUIOptimisation ? productOrOrderEmpty : orderEmpty;
};